import { useQuery, keepPreviousData, useQueryClient } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';

const useQuerySubscriptionKey = () => {
  const { data: user } = useQueryUserInfo();
  return [
    "subscription",
    user?.id
  ];
};
const useQuerySubscription = (queryOptions) => {
  const { client } = useWoody();
  const subscriptionQueryKey = useQuerySubscriptionKey();
  return useQuery({
    queryKey: subscriptionQueryKey,
    queryFn: async () => {
      return await client.v2("/v2/subscription");
    },
    refetchOnWindowFocus: true,
    refetchInterval: 1e3 * 60,
    staleTime: 1e3 * 60,
    placeholderData: keepPreviousData,
    ...queryOptions
  });
};
const useQuerySubscriptionInvalidate = () => {
  const queryClient = useQueryClient();
  const subscriptionQueryKey = useQuerySubscriptionKey();
  return () => queryClient.invalidateQueries({
    queryKey: subscriptionQueryKey
  });
};

export { useQuerySubscription, useQuerySubscriptionInvalidate, useQuerySubscriptionKey };
//# sourceMappingURL=useQuerySubscription.js.map
